import GridData from 'components/GridData/index';

const GuestInformationCard = ({ leadGuestName, guestQffNumber, guestAbnNumber, guestPhoneNumber, guestEmailAddress }) => {
  const cells = [
    { label: 'Lead Guest', value: leadGuestName },
    { label: 'QFF Number', value: guestQffNumber },
    { label: 'ABN Number', value: guestAbnNumber },
    { label: 'Phone Number', value: guestPhoneNumber },
    { label: 'Email Address', value: guestEmailAddress },
  ].filter(({ value }) => value); // filter out those without values

  return <GridData data={cells} data-testid="guest-information" data-hj-suppress />;
};

export default GuestInformationCard;
